import { render, staticRenderFns } from "./ChangeArticleDialog.vue?vue&type=template&id=c0b9b426&scoped=true"
import script from "./ChangeArticleDialog.vue?vue&type=script&lang=js"
export * from "./ChangeArticleDialog.vue?vue&type=script&lang=js"
import style0 from "./ChangeArticleDialog.vue?vue&type=style&index=0&id=c0b9b426&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0b9b426",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VIcon,VRadio,VRow,VSpacer})
